
import ManageAgent from "components/ManageAgent";
import Main from "layouts/Main";


function ManageAgentPage() {

  return (
    <>
    <Main namePage="ตัวแทน"  >
      <div className="layout-content">
        <ManageAgent />
      </div>
      </Main>
    </>
  );
}

export default ManageAgentPage;